import {Button, CardActions, Tooltip} from '@mui/material';

export default function LaunchMeetingButton({canLaunchSession, isZoomLinkCreated, handleSessionLaunch, showCompactButton= false}) {

    const buildTooltipText = () => {
        let tooltipText = '';
        
        if (!isZoomLinkCreated) {
            tooltipText = 'The Zoom link is not created.';
        }

        return tooltipText;
    }

    let tooltipText = buildTooltipText();

    return (
      <CardActions style={{padding: '0', alignSelf: "end"}}>
          <Tooltip title={tooltipText} arrow>
              <Button
                disabled={!canLaunchSession}
                variant="contained" onClick={handleSessionLaunch}
                style={{pointerEvents: 'auto', marginRight: showCompactButton ? '0' : '0.75rem'}}>
                  {showCompactButton ? "Launch" : "Launch Session"}
              </Button>
          </Tooltip>
      </CardActions>
    );
}